export const factorialTipEvents = {
  manuallyClosedTheTip: 'Manually closed the tip',
  clickedTheTooltipLink: 'Clicked the tooltip link',
  tipClosedAutomatically: 'Tip closed automatically',
  goToHelpCenter: 'Go to help center',
}

export const eventsEvents = {
  goToEvent: 'Go to event',
  createEventStart: 'Create event start',
}

export const commsEvents = {
  openWhatsappChatWithEmployee: 'Open a Whatsapp conversation with an employee',
  whatsappChatWithEmployeeShown: 'Show Whatsapp button to chat with an employee',
}

export const discoveryModalEvents = {
  firstStepCompetenciesDiscoveryModal: 'View one competencies discovery modal',
  secondStepCompetenciesDiscoveryModal: 'View two competencies discovery modal',
  thirdStepCompetenciesDiscoveryModal: 'View three competencies discovery modal',
  closeButtonCompetenciesDiscoveryModal: 'Close competencies discovery modal',
  clickCheckItOutCompetenciesDiscoveryModal: 'Click check it out competencies discovery modal',
  clickGotItCompetenciesDiscoveryModal: 'Click got it competencies discovery modal',
}
